/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { jsx, css } from '@emotion/react'
import { default_theme as theme } from '../../emotion/theme'
import { filter, head, get, map, keys, split, size } from 'lodash'
import FieldInfoText from '../../components/layout/FieldInfoText'
import { adminCallForwardingCostStructureVariantList } from '../actions/admin_call_forwarding_cost_structure_variant'
import { CardHeader } from '../../components/layout/CardHeader'
import { LanguageFlag } from '../../components/LanguageFlag'
import { FormikDropdownField } from '../../components/form/Dropdown'
import { FormikCheckboxField } from '../../components/form/CheckboxField'
import { Separator } from '../../components/layout/Separator'
import { Formik, Form, FieldArray, Field } from 'formik'
import Loading from '../../components/Loading'
import { FormikTextarea } from '../../components/form/TextareaField'
import { FormikInputField } from '../../components/form/InputField'
import AdminMainLayout from './AdminMainLayout'
import BusyMask from '../../components/BusyMask'
import Timestamp from '../../components/Timestamp'
import Card from '../../components/layout/Card'
import { Col, Row, Container, Navbar, Nav } from 'react-bootstrap'
import { Form as BootstrapForm } from 'react-bootstrap'
import * as Yup from 'yup'
import {showSuccess, showError} from '../../actions/Error'
import Button from 'react-bootstrap/Button'
import CardInfoText from '../../components/layout/CardInfoText'
import { BlueButton } from '../../components/layout/BlueButton'
import { FormikGeneralFormErrors } from '../../components/form/GeneralFormErrors'
import { handleSubmitResult } from '../../actions/form'

const validationSchema = Yup.object().shape({
    'name': Yup.string().required("Required")
})

class AdminCallForwardingCostStructureVariant extends Component {

    componentDidMount() {
        const { dispatch, call_forwarding_cost_structure_variant_id } = this.props
        dispatch(adminCallForwardingCostStructureVariantList.ensureObjectLoaded(call_forwarding_cost_structure_variant_id))
    }

    componentDidUpdate(prev_props) {
        const { dispatch, call_forwarding_cost_structure_variant_id } = this.props
        dispatch(adminCallForwardingCostStructureVariantList.ensureObjectLoaded(call_forwarding_cost_structure_variant_id))
    }

    onSave = (values, formik_funcs) => {
        const { history, onSubmit, dispatch, call_forwarding_cost_structure_variant_id } = this.props

        const on_ok = function(json) {
            dispatch(adminCallForwardingCostStructureVariantList.invalidateList())
            showSuccess("Saved", "Call Forwarding cost variant saved")

            if ( ! call_forwarding_cost_structure_variant_id ) {
                history.push(`/admin/call_forwarding_cost_structure_variant/${json.id}`)
            }
        }
        if ( call_forwarding_cost_structure_variant_id ) {
            values.id = call_forwarding_cost_structure_variant_id
            return dispatch(adminCallForwardingCostStructureVariantList.saveObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        } else {
            return dispatch(adminCallForwardingCostStructureVariantList.saveNewObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        }
    }
    
    getCellValue = (header_key, item, index) => {
        switch( header_key ) {
            default:
                return undefined
        }
    }

    renderForm(formik_props) {
        const { call_forwarding_cost_structure_variant_options } = this.props

        return (
            <div>
              <Row>
                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Name</BootstrapForm.Label>
                    <FormikInputField name="name" placeholder="Name" />
                  </BootstrapForm.Group>

                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Base prices on variant</BootstrapForm.Label>
                    <FieldInfoText>
                      If a base variant is selected here, then any missing price will be chosen from the base variant. This makes it easier to add variants with only a few price differences from the base.
                    </FieldInfoText>
                    <FormikDropdownField name="inherits_from"
                                         formik_props={formik_props}
                                         options={call_forwarding_cost_structure_variant_options}
                                         empty_selection_label="No base variant"
                                         placeholder="Base variant" />
                  </BootstrapForm.Group>

                </Col>
              </Row>
              <Row>
                <Col>
                  <BlueButton type="submit">Save</BlueButton>
                </Col>
              </Row>
            </div>
        )
    }

    render() {
        const { initial_values, is_loading, is_busy, call_forwarding_cost_structure_variant, call_forwarding_cost_structure_variant_id } = this.props
        const that = this
        const title = `${get(call_forwarding_cost_structure_variant, ["name"], 'New call forwarding cost variant')}`

        return (
            <AdminMainLayout breadcrumbs={[{name: 'admin_home'},
                                           
                                           {name: 'call_forwarding_cost_structure_variants',
                                            label: 'Call Forwarding cost variants',
                                            url: '/admin/call_forwarding_cost_structure_variants'},
                                           
                                           {name: 'call_forwarding_cost_structure_variant',
                                            label: (
                                                <div css={breadcrumb_item}>
                                                  {get(call_forwarding_cost_structure_variant, ["name"], 'New call forwarding cost variant')}
                                                </div>
                                            ),
                                            url: `/admin/call_forwarding_cost_structure_variant/${call_forwarding_cost_structure_variant_id}`
                                           }
            ]}>
              <Container fluid>
                { is_busy && <BusyMask /> }
                { is_loading && <Loading /> }

                <CardHeader title={title} />
                <Separator variant="h30" />
                
                { ! is_loading && 
                  <Formik
                      initialValues={initial_values}
                      onSubmit={that.onSave}
                      enableReinitialize={true}
                      validationSchema={validationSchema}
                      >
                    {formik_props => {
                         const { values } = formik_props
                         return (
                             <Form>
                               <FormikGeneralFormErrors render={(msg) => <Row><Col>{msg}</Col></Row>} />
                               <Row>
                                 <Col>
                                   <Card>
                                     { that.renderForm(formik_props) }
                                   </Card>
                                 </Col>
                               </Row>
                             </Form>
                         )}
                    }
                  </Formik>
                }
              </Container>
            </AdminMainLayout>
        )
    }
    
}

function mapStateToProps(state, props) {
    const call_forwarding_cost_structure_variant_id = get(props, ["match", "params", "call_forwarding_cost_structure_variant_id"], null)
    const call_forwarding_cost_structure_variant = adminCallForwardingCostStructureVariantList.getObject(call_forwarding_cost_structure_variant_id)
    const call_forwarding_cost_structure_variant_options = filter(adminCallForwardingCostStructureVariantList.getAsOptions(), (x) => x.value !== call_forwarding_cost_structure_variant_id)
    
    return {
        call_forwarding_cost_structure_variant_id,
        call_forwarding_cost_structure_variant,
        is_loading: adminCallForwardingCostStructureVariantList.isLoading(),
        is_busy: adminCallForwardingCostStructureVariantList.getIsSavingObject(),
        initial_values: call_forwarding_cost_structure_variant,
        call_forwarding_cost_structure_variant_options
    }
}

export default connect(mapStateToProps)(AdminCallForwardingCostStructureVariant)

const breadcrumb_item = css`
display: flex;
align-items: center;
`
